export const radii = {
  m: '4px',
  ml: '8px',
  l: '16px',
  xl: '24px',
  round: '100%',
  pill: '100vh',
};
